/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetCrmNationalityIdsForTefanawwal Input Action
 */
export class GetCrmNationalityIdsForTefanawwalInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public token: string | undefined;
    constructor(token : string | undefined) {
        this.token = token;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `CRMNATIONALITYIDS`;
    public getCacheObjectType = () => 'CRMNATIONALITYIDS';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetCrmNationalityIdsForTefanawwalData {
    szf_nationalityid: string;
    szf_name: string;
    szf_name_arabic: string;

}

export interface IGetTefanNationalityOptionsData {
    status: boolean,
    data: IGetCrmNationalityIdsForTefanawwalData[] | undefined,
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createNationalityIdsInput = (args: Msdyn365.ICreateActionContext,token:string): Msdyn365.IActionInput => {
    return new GetCrmNationalityIdsForTefanawwalInput(token);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function nationalityIdsDataAction(input: GetCrmNationalityIdsForTefanawwalInput, ctx: Msdyn365.IActionContext): Promise<IGetTefanNationalityOptionsData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    const token = input.token;
    const szfCRMDomainForTefanAwwal = ctx.requestContext.app.config.szfCRMDomainForTefanAwwal;

    const response = await Msdyn365.sendRequest<any>(`${szfCRMDomainForTefanAwwal}/api/data/v9.1/szf_nationalities?$select=szf_nationalityid,szf_name,szf_name_arabic`, "get", {}, {
        headers: {
            'Authorization':`Bearer ${token}`
        }
    });
    if(response && response.data && response.data.value && response.data.value.length > 0){
        return {
            status: true,
            data: response.data.value
        };
    }else{
        return {
            status: false,
            data: undefined
        };
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetTefanNationalityOptionsData>>nationalityIdsDataAction,
    // TODO: Give your data action a unique id
    id: 'GetCrmNationalityIdsForTefanawwal',
    input: createNationalityIdsInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
